var _rect, _path, _circle, _circle2, _text, _text2, _line, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 108,
    viewBox: "40 30 380 108",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 30,
    width: 88,
    height: 88,
    rx: 14,
    fill: "#0C447C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 92,47 C 108,57 62,67 82,73 C 102,79 58,89 76,99",
    fill: "none",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 47,
    r: 6.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 99,
    r: 6.5,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 70,
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fontWeight: 600,
    fill: "#0C447C"
  }, "Sagient")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 277,
    y: 70,
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fontWeight: 600,
    fill: "#378ADD"
  }, " Partners")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 83,
    x2: 420,
    y2: 83,
    stroke: "#B5D4F4",
    strokeWidth: 0.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 146,
    y: 98,
    fontFamily: "Arial, sans-serif",
    fontSize: 13,
    letterSpacing: 1.5,
    fill: "#185FA5"
  }, "AGENTIC AI CONSULTING")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9252106c997f3e0a42efea1aa807295e.svg";
export { ForwardRef as ReactComponent };